var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "fifty-fifty" }, [
    _c("div", { staticClass: "fifty-fifty__wrapper" }, [
      _c(
        "div",
        {
          staticClass: "fifty-fifty__column fifty-fifty__column--media",
          class: [_vm.mediaAligment, _vm.mediaWidth]
        },
        [
          _vm.videoId && _vm.videoType
            ? _c("div", { staticClass: "embed", class: _vm.videoRatio }, [
                _c("iframe", {
                  attrs: {
                    src:
                      _vm.videoType == "youtube"
                        ? "https://www.youtube.com/embed/" + _vm.videoId
                        : "https://player.vimeo.com/video/" + _vm.videoId
                  }
                })
              ])
            : _c("img", {
                staticClass: "fifty-fifty__image",
                attrs: { src: _vm.imageSrc, alt: _vm.imageAlt }
              })
        ]
      ),
      _c(
        "div",
        { staticClass: "fifty-fifty__column fifty-fifty__column--copy" },
        [
          _vm.sectionTitle
            ? _c("h2", [_vm._v(_vm._s(_vm.sectionTitle))])
            : _vm._e(),
          _c("div", { domProps: { innerHTML: _vm._s(_vm.bodyCopy) } }, [
            _vm._v(_vm._s(_vm.bodyCopy))
          ]),
          _vm.ctaUrl && _vm.ctaText
            ? _c(
                "a",
                {
                  staticClass: "fifty-fifty__button button",
                  attrs: { href: _vm.ctaUrl, title: _vm.ctaText }
                },
                [_vm._v(_vm._s(_vm.ctaText))]
              )
            : _vm._e()
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }